<template lang="pug">
#modal-diagnostico-socioambiental
    el-dialog(
        :title="$t('mensagens.diagnosticoSocioambiental.titulo')",
        width='800px',
        center=false,
        :visible.sync='mostrar',
        :before-close='fechar'
    )
        p.mb-1
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
            |
            | {{ pessoa.nomeRazaoSocial }}

        p.mb-1
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.documento') }}:
            |
            | {{ numeralStringFormatTocpfCnpj(pessoa.cpfCnpj) }}

        p.mb-1(v-if='pessoa.email !== "-"')
            b {{ $t('mensagens.operacao.tabela.email') }}:
            |
            | {{ pessoa.email }}

        DiagnosticoSocioambiental.mb-3(
            v-if='isSorted',
            ref='diagnosticoSocioambiental',
            :dadosConsulta='pessoa.diagnostico',
            :cpfCnpj='pessoa.cpfCnpj',
            :habilitar-sinal-aviso='true'
        )

        footer(slot='footer')
            BaseButton(size='mini', @click='fechar') {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import formatters from '@/utils/formatters';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalResultadoDiagnosticoPessoaOperacao',

    components: {
        DiagnosticoSocioambiental,
        BaseButton
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        pessoa: {
            type: Object,
            required: true
        },

        confirmar: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            loadingPDF: false,
            diagnosticoOrdenado: [],
            isSorted: false
        };
    },

    watch: {
        mostrar(val) {
            if (val) {
                this.ordenarDiagnostico();
            }
        },

        isSorted(val) {
        if (val) {
            this.$nextTick(() => {
                this.changeCss();
            });
        }
    }
    },

    mounted() {
        this.$nextTick(() => {
            this.changeCss();
        });
    },

    methods: {

        changeCss() {
            const diagnosticoComponent = this.$refs.diagnosticoSocioambiental;
            if (diagnosticoComponent) {
                const restricoesCard = diagnosticoComponent.$el.querySelector('.card-restricao');
                if (restricoesCard) {
                    restricoesCard.style.border = '2px solid red';
                }
            }
        },

        fechar() {
            this.$emit('fechar');
        },

        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        ordenarDiagnostico() {
            if (this.pessoa.diagnostico && this.pessoa.diagnostico.diagnostico) {
                this.diagnosticoOrdenado = [...this.pessoa.diagnostico.diagnostico].sort((a, b) => {
                    const camadaA = this.$t(`mensagens.camadas.${a.camada.codigo}`);
                    const camadaB = this.$t(`mensagens.camadas.${b.camada.codigo}`);
                    return camadaA.localeCompare(camadaB);
                });

                this.pessoa.diagnostico.diagnostico = this.diagnosticoOrdenado;

                this.isSorted = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
